import { render, staticRenderFns } from "./OnlineClassRoom.vue?vue&type=template&id=69c60d10&scoped=true"
import script from "./OnlineClassRoom.vue?vue&type=script&lang=js"
export * from "./OnlineClassRoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c60d10",
  null
  
)

export default component.exports